import { defineMessages } from "react-intl";

const messages = defineMessages({
  title: {
    id: "passengerPickerModal.title",
    defaultMessage: "Who is travelling?",
    description:
      "Title of passenger picker modal asking the user how many passengers are travelling.",
  },
  confirm: {
    id: "passengerPickerModal.confirm",
    defaultMessage: "Confirm",
    description:
      "The button that confirms the number of passengers the user has selected.",
  },
  adult: {
    id: "passengerPickerModal.adult",
    defaultMessage: "Adult",
    description: "Label of the adult passenger selector buttons.",
  },
  youth: {
    id: "passengerPickerModal.youth",
    defaultMessage: "Youth",
    description: "Label of the youth passenger selector buttons.",
  },
  senior: {
    id: "passengerPickerModal.senior",
    defaultMessage: "Senior",
    description: "Label of the senior passenger selector buttons.",
  },
  adultAgeRange: {
    id: "passengerPickerModal.adultAgeRange",
    defaultMessage: "26+ years",
    description: "Age range that classifies an adult passenger.",
  },
  youthAgeRange: {
    id: "passengerPickerModal.youthAgeRange",
    defaultMessage: "0–25 years", // en-dash unicode: U+02013
    description: "Age range that classifies a youth passenger.",
  },
  seniorAgeRange: {
    id: "passengerPickerModal.seniorAgeRange",
    defaultMessage: "58+ years",
    description: "Age range that classifies a senior passenger.",
  },
  minimumPassengerMessage: {
    id: "passengerPickerModal.minimumPassengerError",
    defaultMessage:
      "To continue your search add at least one passenger that is 18 years or over.",
    description:
      "Error message that appears when the user has deselected the minimum amount of adult passengers.",
  },
  agesRequiredMessage: {
    id: "passengerPickerModal.agesRequiredMessage",
    defaultMessage: "Add the age of each passenger to continue.",
    description:
      "Error message that appears when the user has added passengers without ages.",
  },
  maxPassengersMessage: {
    id: "passengerPickerModal.maxPassengersMessage",
    defaultMessage:
      "Contact the operator directly to book tickets for groups of more than 9 passengers.",
    description:
      "Error message that appears when a user trys to add more than nine passengers.",
  },
  ageDropdownPlaceholder: {
    id: "passengerPickerModal.ageDropdownPlaceholder",
    defaultMessage: "Age",
    description:
      "Placeholder text that appears in the age selector for a passenger before the user has selected an age.",
  },
  adultAddLabel: {
    id: "passengerPickerModal.adultAddLabel",
    defaultMessage: "Add adult passenger",
    description: "Label for adult add button.",
  },
  adultRemoveLabel: {
    id: "passengerPickerModal.adultRemoveLabel",
    defaultMessage: "Remove adult passenger",
    description: "Label for adult remove button.",
  },
  youthAddLabel: {
    id: "passengerPickerModal.youthAddLabel",
    defaultMessage: "Add youth passenger",
    description: "Label for youth add button.",
  },
  youthRemoveLabel: {
    id: "passengerPickerModal.youthRemoveLabel",
    defaultMessage: "Remove youth passenger",
    description: "Label for youth remove button.",
  },
  youthPassengerLabel: {
    id: "passengerPickerModal.youthPassengerLabel",
    defaultMessage: "Youth {passengerNum}",
    description: "Label next to youth passenger age selector.",
  },
  seniorPassengerLabel: {
    id: "passengerPickerModal.seniorPassengerLabel",
    defaultMessage: "Senior {passengerNum}",
    description: "Label next to senior passenger age selector.",
  },
  seniorAddLabel: {
    id: "passengerPickerModal.seniorAddLabel",
    defaultMessage: "Add senior passenger",
    description: "Label for senior add button.",
  },
  seniorRemoveLabel: {
    id: "passengerPickerModal.seniorRemoveLabel",
    defaultMessage: "Remove senior passenger",
    description: "Label for senior remove button.",
  },
  passengerAgeOption: {
    id: "passengerPickerModal.passengerAgeOption",
    defaultMessage: "{passengerAge} year",
    description: 'Label next to passenger age inside selector, "1 year".',
  },
  passengerAgePluralOption: {
    id: "passengerPickerModal.passengerAgePluralOption",
    defaultMessage: "{passengerAge} years",
    description: 'Label next to passenger age inside selector, "x years".',
  },
  search: {
    id: "passengerPickerModal.search",
    defaultMessage: "Search",
    description:
      "Text displayed for searching schedules after date and passenger selection",
  },
  skipPassengerMessage: {
    id: "passengerPickerModal.skipPassenger",
    defaultMessage: "Skip",
    description:
      "Skip button for the user to close the passenger picker modal after choosing a dates on date picker.",
  },
  onePassenger: {
    id: "passengerPickerModal.onePassenger",
    defaultMessage:
      "We can only show pricing for single passengers on this route",
    description:
      "Only one passenger can be shown for static and partially bookable routes.",
  },
  staticPassengerCount: {
    id: "passengerPickerModal.staticPassengerCount",
    defaultMessage: "1",
    description:
      "Only one passenger can be shown for static and partially bookable routes.",
  },
  passengerInfoHeader: {
    id: "Navigation.passengerInfoHeader",
    defaultMessage: "Passengers info",
    description: "Drawer heading, when static passenger picker is clicked",
  },
  staticRoutePricesInfo: {
    id: "Navigation.staticRoutePricesInfo",
    defaultMessage: "We can only show prices for 1 adult for this route",
    description:
      "Contents of the drawer when static passenger picker is clicked",
  },
});

export default messages;
